module.exports = "<p>\n  Letter: {{letter}}\n</p>\n\n\n<div  #rendererContainer></div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/inner-space/main-scene/main-left/main-left.component.html
// module id = ./src/app/inner-space/main-scene/main-left/main-left.component.html
// module chunks = main